import {
    Checkbox, DefaultButton, getId, Icon, Modal, PrimaryButton, ProgressIndicator
} from "@fluentui/react";
import PhoneView from "../../../accounts/views/PhoneView";
import {
    defaultButtonStyles, primaryButtonStyles
} from "../../../common/views/DefaultStyles";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { PhoneModel } from "../../models/PhoneModel";

export type PhoneEntryProps = {
    isEdit: boolean;
    form: PhoneModel;
    errorMessages: any;
    submitting: boolean;
    onValueChange: (field: keyof PhoneModel, value: any) => void;
    onSubmit: () => void;
    onClose: () => void;
}

export default function PhoneEntryView({
    isEdit, form, errorMessages, submitting, onValueChange, onSubmit, onClose
}: PhoneEntryProps) {
    const isMobile = window.innerWidth <= 500;
    const width6 = Utils.getColumnWidth(6);
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const phoneView = () => {
        return <>
            <PhoneView
                showTelegram={false}
                form={form}
                errorMessages={errorMessages}
                onValueChange={onValueChange}
                isRequired={true} />
        </>;
    }

    const telegramCheckbox = () => {
        return <>
            <Checkbox
                label="Telegram Available?"
                checked={form.telegram}
                onChange={(_, v) => onValueChange("telegram", v || false)}
            />
        </>;
    }

    const isPrimaryCheckbox = () => {
        return <>
            <Checkbox
                label="Set Default?"
                checked={form.isPrimary}
                onChange={(_, v) => onValueChange("isPrimary", v || false)}
            />
        </>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row">
            <div className={width6}>
                <DefaultButton
                    onClick={onClose}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const modalHeader = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>
                        {isEdit && <>Edit Phone: {form.id}</>}
                        {!isEdit && <>Add New Phone</>}
                    </div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={true}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {modalHeader()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body ph-15"}>
                <div>{phoneView()}</div>
                <div className="pt-15">{telegramCheckbox()}</div>
                <div className="pt-15">{isPrimaryCheckbox()}</div>

                {!submitting && <div className="pv-20">{buttons()}</div>}

                {submitting && <div className="pv-20">
                    <ProgressIndicator label="Submitting" description="" />
                </div>}
            </div>
        </Modal>
    </>;
}